import { create } from 'zustand';
import { IAppointment, IAuth, ICart, IHeaderItems, IWishlist } from './types';
import createHeaderItemsSlice from './slices/headerItemsSlice';
import createAuthSlice from './slices/authSlice';
import createWishlistSlice from './slices/wishlistSlice';
import createCartSlice from './slices/cartSlice';
import createAppSlice from './slices/appSlice';
import createShowroomSlice from './slices/showroomSlice';
import createBuilderSlice from './slices/builderSlice';
import createAppointmentSlice from './slices/appointmentSlice';
import { IShowroom } from './types/IShowroom';
import { IApp } from './types/IApp';
import { IBuilder } from './types/IBuilder';

const useStore = create<IAuth & IWishlist & ICart & IHeaderItems & IShowroom & IApp & IBuilder & IAppointment>()(
  (...a) => ({
    ...createAuthSlice(...a),
    ...createWishlistSlice(...a),
    ...createCartSlice(...a),
    ...createHeaderItemsSlice(...a),
    ...createBuilderSlice(...a),
    ...createAppSlice(...a),
    ...createShowroomSlice(...a),
    ...createAppointmentSlice(...a),
  })
);

export default useStore;
